export interface ScoreColors {
  limit: number;
  backgroundColor: string;
  foregroundColor: string;
}

export const EMPLOYER_SCORES: Record<string, ScoreColors> = {
  T1: { limit: 0.06, backgroundColor: '#a9d08d', foregroundColor: '#000' },
  T2: { limit: 0.04, backgroundColor: '#bdd7ee', foregroundColor: '#000' },
  T3: { limit: 0.02, backgroundColor: '#f8cbad', foregroundColor: '#000' },
  T4: { limit: 0, backgroundColor: '#c65911', foregroundColor: '#fff' },
};

export const EMPLOYER_SCORES_CHOICE_LIST = Object.keys(EMPLOYER_SCORES).map(element => ({ id: element, name: element }));
